<template>
  <div class>
    <toptitle :title="topTitle" :subtitle="topSubTitle"></toptitle>
    <div class="products-container">
      <div class="container">
        <div class="row d-flex">
          <leftsidebar class="order-md-1 order-2"></leftsidebar>
          <div class="products-box col-md-9 order-md-2 order-1">
            <div class="products-title">
              <span v-if="currentLanguage == 'CN'">产品信息</span>
              <span v-else-if="currentLanguage == 'EN'">Product information</span>
              <span v-else-if="currentLanguage == 'JP'">製品情報</span>
            </div>
            <div class="row products-model">
              <div class="col-md-5 products-swiper">
                <swiper :image="productsData.image"></swiper>
              </div>
              <div class="col-md-7 products-info">
                <div class="products-title">
                  <span>{{productsData.name}}</span>
                </div>
                <div class="products-text">
                  <pre>
                    {{productsData.info}}
                  </pre>
                </div>
                <div v-if="productsData.category !== '61934084232c0fd7858b'" class="products-btn d-flex">
                  <a href="tel:18028377527" class="products-btn-phone">
                    <p class="products-btn-title">{{basicinfoData.phone.split("：")[0]}}</p>
                    <p class="products-btn-subtitle">{{basicinfoData.phone.split("：")[1]}}</p>
                  </a>
                  <a href="mailto:sc@gw-ai.com" class="products-btn-email">
                    <p class="products-btn-title">{{basicinfoData.email.split("：")[0]}}</p>
                    <p class="products-btn-subtitle">{{basicinfoData.email.split("：")[1]}}</p>
                  </a>
                </div>
                <div v-if="productsData.category == '61934084232c0fd7858b'" class="products-btn d-flex">
                  <a href="tel:13650450517" class="products-btn-phone">
                    <p class="products-btn-title">{{basicinfoData.phone.split("：")[0]}}</p>
                    <p class="products-btn-subtitle">136-5045-0517</p>
                  </a>
                  <a href="mailto:apple-yen@gw-ai.com" class="products-btn-email">
                    <p class="products-btn-title">{{basicinfoData.email.split("：")[0]}}</p>
                    <p class="products-btn-subtitle">apple-yen@gw-ai.com</p>
                  </a>
                </div>
              </div>
            </div>
            <div class="products-title products-body-title">
              <span v-if="currentLanguage == 'CN'">产品详情</span>
              <span v-else-if="currentLanguage == 'EN'">Product details</span>
              <span v-else-if="currentLanguage == 'JP'">製品詳細</span>
            </div>
            <div class="products-body" v-html="productsData.body"></div>
            <hr>
              <router-link tag="a" to='/products' class="news-list">&lt;&lt; 返回产品列表</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import swiper from '../components/swiper'
import baseDataCN from '../data/CN/basicinfoData_CN.json'
import baseDataEN from '../data/EN/basicinfoData_EN.json'
import baseDataJP from '../data/JP/basicinfoData_JP.json'
import productslistCN from '../data/CN/productslist_CN.json'
import productslistEN from '../data/EN/productslist_EN.json'
import productslistJP from '../data/JP/productslist_JP.json'
export default {
  props: {
    id: { required: true }, // 产品id
  },
  data() {
    return {
      topTitle: '产品中心',
      topSubTitle: '专业光学自动化设备，实力见证品牌',
      productsData: {},
      basicinfoData: {},
      currentLanguage: '' // 当前语言
    }
  },
  mounted() {
      const _this = this
      window.addEventListener('setItemEvent', function(e) {
          // e.key : 是值发生变化的key
          // 例如 e.key==="token";
          // e.newValue : 是可以对应的新值
          if (e.key === 'language') {
              var d = e.newValue
              _this.currentLanguage = e.newValue
              if (d === 'CN') {
                  _this.basicinfoData = baseDataCN
                  _this.fetch(productslistCN)
              } else if (d === 'EN') {
                  _this.basicinfoData = baseDataEN
                  _this.fetch(productslistEN)
              } else if (d === 'JP') {
                  _this.basicinfoData = baseDataJP
                  _this.fetch(productslistJP)
              }
          }
      })
  },
  methods: {
    fetch(list) {
        for (var i = 0; i<list.length; i++) {
            for (var j = 0; j<list[i].productsList.length; j++) {
                if (list[i].productsList[j]._id == this.id) {
                    this.productsData = list[i].productsList[j];
                    break;
                }
            }
        }
    },
    // 查询所有的基本信息
    findBasicinfo() {
        var lg = localStorage.getItem('language')
        this.currentLanguage = lg
        if (lg === 'CN') {
            this.basicinfoData = baseDataCN
            this.fetch(productslistCN)
        } else if (lg === 'EN') {
            this.basicinfoData = baseDataEN
            this.fetch(productslistEN)
        } else if (lg === 'JP') {
            this.basicinfoData = baseDataJP
            this.fetch(productslistJP)
        }
    }
  },
  created() {
    this.findBasicinfo()
  },
  components: {
    swiper: swiper
  }
}
</script>
<style lang="scss" scoped>
  .products-body-title {
    margin-top: 30px;
  }
.products-container {
  padding: 30px 0;
}
.products-box {
  margin-bottom: 26px;
}
.products-title {
  border-bottom: 1px solid #cccccc;
  margin-bottom: 6px;
}
.products-title span {
  display: inline-block;
  font-size: 22px;
  padding: 4px 0;
  position: relative;
  bottom: -1px;
  border-bottom: 1px solid #048bd4;
  color: #048bd4;
}

@media (max-width: 768px) {
  .products-info {
    margin-top: 30px;
  }
  .products-btn-title {
  font-size: 14px !important;
  }

.products-btn-subtitle {
  font-size: 18px !important;
  }
  .products-btn {
    margin-top: 30px !important;
  }
  .products-body {
    margin-top: 40px !important;
  }
}

.products-model {
  margin-top: 30px;
}
.products-text {
  position: relative;
  top: -42px;
  margin-top: 20px;
}
.products-text pre{
  color: #666;
  line-height: 32px;
  font-size: 16px;
}

.products-info {
  width: 100%;
}
.products-btn {
  margin-top: 30px;
  width: 100%;
}

.products-btn a{
  width: 100%;
  display: block;
  padding: 6px 10px;
  border-radius: 12px;
  flex: 1;
  color: #fff;
}

.products-btn-phone:hover {
  background-image: linear-gradient(#f88f38, #e76c29);
}
.products-btn-email:hover {
  background-image: linear-gradient(#44b6f3, #1b94d4);
}

.products-btn-phone {
  background-image: linear-gradient(#fc8526, #f15500);
  border: 1px solid #f15500;
  margin-right: 15px;
}
.products-btn-email {
  background-image: linear-gradient(#26adf6, #048bd4);
  border: 1px solid #048bd4;
}

.products-btn-title {
  font-size: 16px;
}

.products-btn-subtitle {
  font-size: 20px;
}

.products-body img{
  width: 100%;
}

.products-body  {
  margin-top: 30px;
}
hr {
  color: #f2f2f2;
}
.news-list {
  font-size: 16px;
  color: #048bd4;
  display: inline-block;
  margin-bottom: 30px;
}
</style>